import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getAllocatedDistricts } from "../stateAgencyApi";

/** Portfolio Account (dedicated login) and Portfolio Admin (a person). */
export const PORTFOLIO_ROLE_IDS = [14, 15];

/**
 * Whether the signed-in user should see Portfolio Management in the nav.
 *
 * Role alone is not enough. Portfolio admins are assigned to a group via
 * AccountAllocation and KEEP their existing role — Candy Vidovich administers the
 * Pomptonian portfolio while remaining a District Admin (roleId 2). So a user with
 * no portfolio role still gets the menu if they hold an allocation.
 *
 * The lookup is skipped entirely for users who already qualify by role, and
 * vw_AccountAllocatedDistricts is small (one row per user x district they oversee).
 */
export default function usePortfolioAccess() {
  const login = useSelector((s) => s.login?.LoginDetails);
  const roleId = Number(login?.roleId);
  const userId = login?.userId;
  const byRole = roleId === 1 || PORTFOLIO_ROLE_IDS.includes(roleId);

  const [hasAllocation, setHasAllocation] = useState(false);

  useEffect(() => {
    if (byRole || !userId) return undefined;
    let alive = true;
    (async () => {
      try {
        const rows = await getAllocatedDistricts();
        if (!alive) return;
        const uid = String(userId).trim().toUpperCase();
        setHasAllocation(
          (rows || []).some((r) => String(r.UserId || "").trim().toUpperCase() === uid)
        );
      } catch {
        /* nav simply stays hidden */
      }
    })();
    return () => {
      alive = false;
    };
  }, [byRole, userId]);

  return byRole || hasAllocation;
}
